/**
 * Grows a control's hit area to 44 x 44 px (Apple's minimum for a thumb) without moving anything.
 *
 * A pseudo-element is centred on the control, as big as the control or 44 px each way, whichever is more,
 * and a press anywhere on it is a press on the control: the control's own glyph, padding and the layout
 * around it are exactly as they were. That is the point, because a row of 15 px labels or a 24 px checkbox
 * cannot become 44 px boxes without rearranging the screen they sit in.
 *
 * Two things it does not do. It cannot reach past an ancestor with `overflow: hidden`, which clips the
 * pseudo-element's hits as it clips its paint. And two controls closer together than 44 px share the overlap,
 * and the later one in the document wins it; the controls that carry it have at least their own width between
 * them, so the overlap is vertical slack and not a neighbour's target.
 *
 * `before:content-['']` is spelled out although Tailwind v4 supplies an empty `content` for `before:`: a
 * pseudo-element with no `content` is not generated, and this class list is useless if it is not.
 */
export const HIT_44 =
  "relative before:absolute before:left-1/2 before:top-1/2 before:size-full before:min-h-11 before:min-w-11 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']"

/**
 * The same 44 x 44 px, anchored to the control's left edge so it grows to the right only.
 *
 * For a control that sits flush against an ancestor which clips (the checkbox at the left edge of a form in a
 * tab panel: measured, a centred area lost its left 10 px to the clip and came out 34 px wide). To the right,
 * the area runs over the gap and into the control's own label, which toggles the same control, so the whole
 * 44 px answers one press the same way.
 */
export const HIT_44_START =
  "relative before:absolute before:left-0 before:top-1/2 before:size-full before:min-h-11 before:min-w-11 before:-translate-y-1/2 before:content-['']"
